
import React from "react";
import { useState } from "react";
import ProgressBarLocal from "../components/ProgressBarLocal";
import ProgressBarPercentage from "../components/ProgressBarPercentage";

const ProgressBar = () => {

    const [progress, setProgress] = useState(60);

    return (
        <div className="container mt-6">
            <div className="card">
                <div className="card-header">
                    <h5>Progress Bar</h5>
                </div>
                <div className="card-body">
                    <ProgressBarLocal progress={100} color="#007bff" height="25px" />
                    <ProgressBarLocal progress={30} color="#ff5733" height="25px" />
                    <ProgressBarLocal progress={70} color="#28a745" height="25px" />
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <h5>Progress Bar With Percentage</h5>
                </div>
                <div className="card-body">
                    <ProgressBarPercentage />
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
